import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "eventNotHolding"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 3,
  id: "timetable-top-guest"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 4,
  id: "timetable-top-login"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 5,
  id: "single-top-guest"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 6,
  id: "single-top-login"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 7,
  class: "m-5 text-center",
  id: "loading-spinner"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "読み込み中です")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 8,
  id: "api-error"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 10,
  id: "timetable-bottom-guest"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 11,
  id: "timetable-bottom-login"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 12,
  id: "single-bottom-guest"
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 13,
  id: "single-bottom-login"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["action"]

import { ref, onMounted, nextTick } from 'vue';
//  import { useRoute } from 'vue-router';
//  const route = ref(useRoute());

	// replace()するためだけ
  import { useRouter } from 'vue-router';
  import { useStorage } from 'vue3-storage';
  import { CallbackResult } from 'vue3-storage/dist/lib/types';
  import axios from 'axios';
  import qs from 'qs';

  import HomeView from '@/views/HomeView.vue';
  import ShoppingCart from '@/components/ShoppingCart.vue';
  import TimezoneErrorModal from '@/components/TimezoneErrorModal.vue';
  import ConfirmCancelModal from '@/components/ConfirmCancelModal.vue';
  import LoginBox from '@/components/LoginBox.vue';
  import CarouselBox from '@/components/CarouselBox.vue';
  import NoticeBox from '@/components/NoticeBox.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const router = useRouter();
  
  const axiosOptions = {
    withCredentials: true
    // headers: {'Access-Control-Allow-Origin': '*'}
  };
  let linkBaseURL = '';
  let formBaseURL = '';
  if (window.webtanEventConfig) {
    if (window.webtanEventConfig.api && window.webtanEventConfig.api.baseUrl) {
      axiosOptions.baseURL = window.webtanEventConfig.api.baseUrl;
      axiosOptions.baseURL = axiosOptions.baseURL.trim();
      if (axiosOptions.baseURL.match(/\/$/)) {
        axiosOptions.baseURL = axiosOptions.baseURL.slice(0, -1);
      }
    }
    if (window.webtanEventConfig.auth && window.webtanEventConfig.auth.username && window.webtanEventConfig.auth.password) {
      axiosOptions.auth = {};
      axiosOptions.auth.username = window.webtanEventConfig.auth.username;
      axiosOptions.auth.password = window.webtanEventConfig.auth.password;
    }
    if (window.webtanEventConfig.link && window.webtanEventConfig.link.baseUrl) {
      linkBaseURL = window.webtanEventConfig.link.baseUrl;
      linkBaseURL = linkBaseURL.trim();
      if (linkBaseURL.match(/\/$/)) {
        linkBaseURL = linkBaseURL.slice(0, -1);
      }
    }
    if (window.webtanEventConfig.form && window.webtanEventConfig.form.baseUrl) {
      formBaseURL = window.webtanEventConfig.form.baseUrl;
      formBaseURL = formBaseURL.trim();
      if (formBaseURL.match(/\/$/)) {
        formBaseURL = formBaseURL.slice(0, -1);
      }
    }
  }
  let eventHolding = ref(true); // イベントが開催中かどうか
  if ('undefined' == typeof(window.webtanEventHolding) || window.webtanEventHolding === false) { // 終了している
    eventHolding.value = false;
  }
  if ('undefined' == typeof(window.webtanEventAPIisAlive) || window.webtanEventAPIisAlive === false) { // 静的化されている
    eventHolding.value = false; // 強制的にクローズ
  }
  let eventAPIisAlive = ref(true); // イベントが静的化されているかどうか
  if ('undefined' == typeof(window.webtanEventAPIisAlive) || window.webtanEventAPIisAlive === false) { // 静的化されている
    eventAPIisAlive.value = false;
  }

  const cart = ref([]);
  const makeStorageKey = () => {
    const url = 'webtan_' + encodeURIComponent(window.location.pathname.split('/').join('_'));
    return url;
  };
  const storageName = makeStorageKey();
  const date = new Date();
  date.setDate(60);	// 60日後
  const expireDate = date.toString();
  const storage = useStorage();

  let sessions = ref([]); // 全セッションのリスト
  let single = ref(false); // 詳細ページかどうか

  const entryList = ref([]); // 申込済リスト
  let concatList = ref([]); // カート + 申込済リスト


  let shareURL = ref('');
  let seminar_session = ref('');
  const isSingle = () => {
    const seminarSessionParam = getSeminarSessionParam();
    const foundSession = findSessionById(seminarSessionParam);
    if (seminarSessionParam) {
    	if (foundSession) {
	      single.value = true;
  	    seminar_session.value = seminarSessionParam;
  	  }
  	  else {
  	  	router.replace({path:'/'});
  	  }
    }

/*
    // シェア用URL
    shareURL.value = window.location.protocol + window.location.hostname + window.location.pathname;
    if (seminarSessionParam) {
      shareURL.value = shareURL.value + '?seminar_session=' + seminarSessionParam;
    }
*/
  }

  const getSeminarSessionParam = () => {
    // useRoute() が一瞬ずらさないとURLを把握しないことがあるため手動で解析する
    const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    if (queryParams.seminar_session) {
      return queryParams.seminar_session.replace('seminar_', '');
    }
    return null;
  }

//  isSingle(); // 即時に実行する

  const webtanForm = ref();

  const login = ref(false);

  const timetableTopGuest = ref();
  const timetableBottomGuest = ref();
  const timetableTopLogin = ref();
  const timetableBottomLogin = ref();
  const singleTopGuest = ref();
  const singleBottomGuest = ref();
  const singleTopLogin = ref();
  const singleBottomLogin = ref();
  const eventEndedNotice = ref();
  const getSessionsErrorMessage = ref();
  const getLoginBoxMessage = ref();

  const webtanPlayWebinarLabels = window.webtanPlayWebinarLabels;
  let webinarMainLabel = ref('視聴する');
  let webinarSubLabel = ref('');
  if (webtanPlayWebinarLabels) {
    if (webtanPlayWebinarLabels.webinarMainLabel != undefined || webtanPlayWebinarLabels.webinarMainLabel != null) { // 空文字の代入を許す
      webinarMainLabel.value = webtanPlayWebinarLabels.webinarMainLabel;
    }
    if (webtanPlayWebinarLabels.webinarSubLabel != undefined || webtanPlayWebinarLabels.webinarSubLabel != null) { // 空文字の代入を許す
      webinarSubLabel.value = webtanPlayWebinarLabels.webinarSubLabel;
    }
  }

  let timezoneError = ref(false);
  let timezoneErrorMessage = ref('');
  let confirmCancel = ref(false);
  let confirmCancelMessage = ref('');
  let cancelSession = ref({});

  let getSessionsFail = ref(false);

  const closeTimezoneErrorModal = () => {
    timezoneError.value = false;
  }

  const colseConfirmCancelModal = () => {
    confirmCancel.value = false;
  }

  let shoppingCart = ref(false);
  const toggleShoppingCart = () => {
    shoppingCart.value = !shoppingCart.value;
  }

  const attachBodyClickShoppingCartClose = () => {
    document.addEventListener('click', closeShoppingCartIfOpen);
  }

  // eslint-disable-next-line
  const closeShoppingCartIfOpen = (evt) => {
    if (shoppingCart.value) {
      shoppingCart.value = !shoppingCart.value;
    }
  }

  const setStorage = () => {
    storage
      .setStorage({
        key: storageName,
        data: { cart: cart.value, expire: expireDate }
      })
      .then((successCallback: CallbackResult) => {
//        console.log(successCallback.errMsg);
      })
      .catch((failCallback: CallbackResult) => {
        console.warn(failCallback.errMsg);
      });
  }

  const removeStorage = () => { // 期限切れのとき初期化する
    storage
      .removeStorage({key: storageName})
      .then((successCallback: CallbackResult) => {
//        console.log(successCallback.errMsg);
        setStorage(); // 空値を保存してキーをつくる
      })
      .catch((failCallback: CallbackResult) => {
        console.warn(failCallback.errMsg);
      });
  }

  const getStorage = () => {
    storage
      .getStorage({key: storageName})
      .then((successCallback: CallbackResult) => {
//        console.log(successCallback.errMsg);
        if (new Date(successCallback.data.expire) < new Date()) {
          removeStorage();
          cart.value = [];
        } else {
          cart.value = successCallback.data.cart;
        }
      })
      .catch((failCallback: CallbackResult) => {
        console.log(failCallback.errMsg);
        // 初回のアクセス（キーがないとき）はこちらに来る
        setStorage(); // 空値を保存してキーをつくる
      });
  }

  const getStorageFromServer = () => {
    axios.get("/get_regedsemi.php", axiosOptions)
      .then((response) => {
        if (response.status == 200) {
          if (response.data) {
            entryList.value = response.data.data;
            // カート内にある重複するセッションは削除する
            if (cart.value) {
              entryList.value.forEach((row) => {
                const index = cart.value.indexOf(row);
                if (index != -1) {
                  cart.value.splice(index, 1);
                }
              });
            }
            setStorage();
            // console.log('entryList.value', entryList.value);
          } else {
            entryList.value = [];
          }
        }
      })
      .catch((failCallback: CallbackResult) => {
        console.warn(failCallback.errMsg);
      });
  }

  const addItem = (item: string) => {
    const checkDuplicatesAndSetStorage = () => {
      concatList.value = cart.value.concat(entryList.value);
      if (concatList.value) {
        let exist = false;
        concatList.value.forEach((row) => {
          if (row === item) {
            exist = true;
          }
        });
        if (exist) {
          timezoneError.value = true;
          timezoneErrorMessage.value = "このセッションはすでに視聴リストに追加されています。";
        } else {
          let enable = true;
          let sortkey = 0;
          sessions.value.forEach((session) => {
            if (item === session.layout_id) {
              sortkey = session.sortkey;
            }
          });
          concatList.value.forEach((row) => {
            sessions.value.forEach((session) => {
              if (row === session.layout_id) {
                if (sortkey === session.sortkey) {
                  enable = false;
                }
              }
            });
          });
          if (enable) {
            cart.value.push(item);
            concatList.value = cart.value.concat(entryList.value);
            setStorage();
            if (!shoppingCart.value) {
              shoppingCart.value = true;
            }
          } else {
            timezoneError.value = true;
            timezoneErrorMessage.value = "同じ時間帯のセッションは重複して追加できません。視聴リストから同じ時間帯のセッションを削除してから追加してください。";
          }
        }
      }
    }
    storage
      .getStorage({key: storageName})
      .then((successCallback: CallbackResult) => {
//        console.log(successCallback.errMsg);
        cart.value = successCallback.data.cart;
        if (login.value) {
          // サーバーから保存された申し込み済みリストを取得する
          axios.get("/get_regedsemi.php", axiosOptions)
            .then((response) => {
              if (response.status == 200) {
                if (response.data) {
                  entryList.value = response.data.data;
                } else {
                  entryList.value = [];
                }
                checkDuplicatesAndSetStorage();
              }
            })
            .catch((failCallback: CallbackResult) => {
              console.warn(failCallback.errMsg);
            });
        } else {
          checkDuplicatesAndSetStorage();
        }
      })
      .catch((failCallback: CallbackResult) => {
        console.log(failCallback.errMsg);
        // 初回のアクセス（キーがないとき）はこちらに来る
        setStorage(); // 空値を保存してキーをつくる
      });
  }

  const removeItem = (item: string) => {
    if (cart.value) {
      const index = cart.value.indexOf(item);
      if (index != -1) {
        cart.value.splice(index, 1);
      }
    }
    setStorage();
    if (!shoppingCart.value) {
      shoppingCart.value = true;
    }
  }

  const cancelItem = (session: object) => {
    confirmCancelMessage.value = '<div class="mb-3">以下のセッションの視聴をキャンセルしてよろしいですか？</div>' + '<div class="fw-bold">' + session.id + '<br>' + session.title + '</div>';
    cancelSession.value = session;
    confirmCancel.value = true;
  }

  const doCancelSession = (session: object) => {
    axios.get("/get_cancelsemi.php?layout_id=" + session.layout_id, axiosOptions) // セッションキャンセルAPI, axiosOptionsI
      .then((response) => {
        if (response.status == 200) {
          if (response.data.result === true) {
            if (entryList.value) {
              const index = entryList.value.indexOf(session.layout_id);
              if (index != -1) {
                entryList.value.splice(index, 1);
              }
            }
            // ブラウザストレージから保存されたカート情報を取得する
            getStorage();
            // サーバーから保存された申し込み済みリストを取得する
            getStorageFromServer(); // 上記で画面は更新済みだが、念のためサーバーと同期する
            if (!shoppingCart.value) {
              shoppingCart.value = true;
            }
          } else {
            console.log('セッションのキャンセルに失敗しました。');
          }
        }
      })
      .catch((failCallback) => {
        console.log(failCallback.errMsg);
      });
  }

  const getSessions = async () => {
    const makeSortKey = (temp) => {
      let tempAry = [];
      temp.forEach((session) => {
        // ソートキーをつくる
        const date = session.date.split('-');
        const time = session.timeStart.split(':');
        const d = new Date();
        d.setFullYear(date[0]);
        d.setMonth(parseInt((date[1]) - 1));
        d.setDate(parseInt(date[2]));
        d.setHours(time[0]);
        d.setMinutes(parseInt(time[1]));
        session.sortkey = d.getFullYear().toString() + d.getMonth().toString().padStart(2, '0') + d.getDate().toString().padStart(2, '0') + d.getHours().toString().padStart(2, '0') + d.getMinutes().toString().padStart(2, '0');
        tempAry.push(session);
      });
      tempAry.sort((a, b) => {
        return a.sortkey - b.sortkey;
      });
      return tempAry;
    }
    if (eventAPIisAlive.value === false) {
      let staticSessionsJSON = [];
      if (window.webtanEventStaticJSON) {
        staticSessionsJSON = makeSortKey(window.webtanEventStaticJSON);
      }
      sessions.value = staticSessionsJSON;
    } else {
      await axios.get("/get_session.php", axiosOptions)
        .then((response) => {
          if (response.status == 200) {
            sessions.value = makeSortKey(response.data);
          }
        })
        .catch((failCallback) => {
          getSessionsFail.value = true;
          console.log(failCallback.errMsg);
        });
    }
    modifySessionDocumentsValues();
  }
  
  /**
   * sessionのdocumentsが配列じゃなくて1個のオブジェクトの場合は配列に変える
   */
  const modifySessionDocumentsValues = () => {
    sessions.value.forEach((session) => {
      if (!Array.isArray(session.documents)) {
      	session.documents = [JSON.parse(JSON.stringify(session.documents))];
      }
    });
  }

  const getLoginStatus = () => {
    const replaceWebContents = () => {
    
      const appendExtractedCss = (sourceElemId, destAttrs) => {
        const cssElem = document.getElementById(sourceElemId);
        if (cssElem) {
          const newStyleElem = document.createElement('style');
          newStyleElem.innerHTML = cssElem.innerHTML;
          if (destAttrs && destAttrs.constructor.name == 'Object') {
            for (const k in destAttrs) {
              newStyleElem.setAttribute(k, destAttrs[k]);
            }
          }
          document.head.appendChild(newStyleElem);
        }
      };

      const extractHTMLElem = (sourceElemId, refVar) => {
        const htmlElem = document.getElementById(sourceElemId);
        if (htmlElem) {
          refVar.value = htmlElem.innerHTML;
          htmlElem.remove();
        }
      };
      // Vue コントロール外の表示をコントロールする
      if (!login.value && !single.value) {
        appendExtractedCss('js-webtan-timetable-guest-css', {
          'data-setting-source': 'js-webtan-timetable-guest-css',
        });
      }
      if (login.value && !single.value) {
        appendExtractedCss('js-webtan-timetable-login-css', {
          'data-setting-source': 'js-webtan-timetable-login-css',
        });
      }
      if (!login.value && single.value) {
        appendExtractedCss('js-webtan-single-guest-css', {
          'data-setting-source': 'js-webtan-single-guest-css',
        });
      }
      if (login.value && single.value) {
        appendExtractedCss('js-webtan-single-login-css', {
          'data-setting-source': 'js-webtan-single-login-css',
        });
      }
      extractHTMLElem('js-webtan-timetable-top-guest', timetableTopGuest);
      extractHTMLElem('js-webtan-timetable-bottom-guest', timetableBottomGuest);
      extractHTMLElem('js-webtan-timetable-top-login', timetableTopLogin);
      extractHTMLElem('js-webtan-timetable-bottom-login', timetableBottomLogin);
      extractHTMLElem('js-webtan-single-top-guest', singleTopGuest);
      extractHTMLElem('js-webtan-single-bottom-guest', singleBottomGuest);
      extractHTMLElem('js-webtan-single-top-login', singleTopLogin);
      extractHTMLElem('js-webtan-single-bottom-login', singleBottomLogin);
      extractHTMLElem('js-webtan-event-ended-notice', eventEndedNotice);
      extractHTMLElem('js-webtan-api-error', getSessionsErrorMessage);
      extractHTMLElem('js-webtan-login-box-message', getLoginBoxMessage);
/*
      const twitter = document.createElement('script');
      twitter.src = 'https://platform.twitter.com/widgets.js';
      twitter.charset = 'utf-8';
      twitter.async = true;
      document.head.appendChild(twitter);
      const facebook = document.createElement('script');
      facebook.innerHTML = '(function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; js = d.createElement(s); js.id = id; js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0"; fjs.parentNode.insertBefore(js, fjs); }(document, "script", "facebook-jssdk"));';
      document.head.appendChild(facebook);
      const hatena = document.createElement('script');
      hatena.src = 'https://b.st-hatena.com/js/bookmark_button.js';
      hatena.charset = 'utf-8';
      hatena.async = 'async';
      document.head.appendChild(hatena);
      const line = document.createElement('script');
      line.src = 'https://www.line-website.com/social-plugins/js/thirdparty/loader.min.js';
      line.charset = 'utf-8';
      line.async = 'async';
      line.defer = 'defer';
      document.head.appendChild(line);
      const note = document.createElement('script');
      note.src = 'https://cdn.st-note.com/js/social_button.min.js';
      note.charset = 'utf-8';
      note.async = 'async';
      document.head.appendChild(note);
*/
    }
    if (eventAPIisAlive.value === false) {
      login.value = false;
      replaceWebContents();
    } else {
      axios.get("/get_logined.php", axiosOptions)
        .then((response) => {
          if (response.status == 200) {
            login.value = response.data.status;
            
            // 検証用モード
            /*
            if (route.value.query.mode === 'login') {
              // 開発モードでひらいたときはログオフ時と同じ表示にする
              login.value = true;
            }
            */
            
            if (login.value) {
              // ブラウザストレージから保存されたカート情報を取得する
              getStorage();
              // サーバーから保存された申し込み済みリストを取得する
              getStorageFromServer();
            } else {
              // ブラウザストレージから保存されたカート情報を取得する
              getStorage();
            }
            nextTick(() => {
              concatList.value = cart.value.concat(entryList.value);
              replaceWebContents();
            });
          }
        })
        .catch((failCallback) => {
          console.log(failCallback.errMsg);
          replaceWebContents();
        });
    }
  }

  const findSession = (cart: string[]) => {
    let foundSessions = [];
    if (cart) {
      cart.forEach((row) => {
        sessions.value.forEach((session) => {
          if (row === session.layout_id) {
            foundSessions.push(session);
          }
        });
      });
    }
    foundSessions = foundSessions.sort((a, b) => {
      return a.sortkey - b.sortkey;
    });
    return foundSessions;
  }
  const findSessionById = (sessionId: string) => {
    let foundSession = null;
    if (sessionId) {
      for (let i = 0; i < sessions.value.length; i++) {
        if (sessionId == sessions.value[i].id) {
          foundSession = sessions.value[i];
          return true;
        }
      }
    }
    return foundSession;
  }

  const submitForm = () => {
    const stringifyCart = () => {
      const existInputs = webtanForm.value.querySelectorAll('input[type="hidden"]');
      if (existInputs.length != 0) {
        for (var i = 0; i < existInputs.length; i++) {
          existInputs[i].remove(); // 2重でパラメータが追加されるのを防ぐ
        }
      }
      const layout_id_list = [];
      const sessions = findSession(cart.value);
      sessions.forEach((session) => {
        layout_id_list.push(session.layout_id);
      });
      const data = JSON.stringify(layout_id_list);
      const dom = document.createElement('input');
      dom.type = 'hidden';
      dom.name = 'data';
      dom.value = data;
      webtanForm.value.appendChild(dom);
      const entry_layout_id_list = [];
      const entrySessions = findSession(entryList.value);
      entrySessions.forEach((session) => {
        entry_layout_id_list.push(session.layout_id);
      });
      const entryData = JSON.stringify(entry_layout_id_list);
      const entryDom = document.createElement('input');
      entryDom.type = 'hidden';
      entryDom.name = 'entryList';
      entryDom.value = entryData;
      webtanForm.value.appendChild(entryDom);
      nextTick(() => {
        // console.log('data', data);
        // console.log('entryData', entryData);
        webtanForm.value.submit();
      });
    }
    if (cart.value.length) {
      stringifyCart();
    } else {
      timezoneError.value = true;
      timezoneErrorMessage.value = "視聴するセッションを選んでから「参加申込する」ボタンを教えください。";
    }
  }

  const openLink = (url: string) => {
    // セッション個別ページから「もどる」
    if (linkBaseURL) {
      url = linkBaseURL + url;
    }
    window.open(url, "_self", "noreferrer");
  }

  const openLinkWithNewWindow = (url: string) => {
    // セッション個別ページ
    if (linkBaseURL) {
      url = linkBaseURL + url;
    }
    window.open(url, "_blank", "noreferrer");
  }

  const openExternalLink = (url: string) => {
    // ウェビナーの視聴
    window.open(url, "_self", "noreferrer");
  }

  const openExternalLinkWithNewWindow = (url: string) => {
    // 資料ダウンロード
    window.open(url, "_blank", "noreferrer");
  }

  const openMyPageLink = (url: string) => {
    // マイページ
    let target = '_blank';
    if (login.value) {
      target = '_self';
    }
    if (formBaseURL) {
      url = formBaseURL + url;
    }
    window.open(url, target, "noreferrer");
  }

  onMounted (async () => {
    await getSessions();
    isSingle();
    getLoginStatus();
    attachBodyClickShoppingCartClose();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(sessions) && _unref(sessions).length && _unref(eventHolding) && _unref(eventAPIisAlive))
      ? (_openBlock(), _createBlock(ShoppingCart, {
          key: 0,
          cart: cart.value,
          entryList: entryList.value,
          sessions: _unref(sessions),
          onRemoveItem: removeItem,
          onCancelItem: cancelItem,
          onToggleShoppingCart: toggleShoppingCart,
          shoppingCart: _unref(shoppingCart),
          onSubmitForm: submitForm,
          login: login.value,
          webinarMainLabel: _unref(webinarMainLabel),
          webinarSubLabel: _unref(webinarSubLabel),
          onOpenExternalLink: openExternalLink
        }, null, 8, ["cart", "entryList", "sessions", "shoppingCart", "login", "webinarMainLabel", "webinarSubLabel"]))
      : _createCommentVNode("", true),
    (!_unref(eventHolding))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (eventEndedNotice.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: eventEndedNotice.value
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(eventAPIisAlive))
      ? (_openBlock(), _createBlock(LoginBox, {
          key: 2,
          login: login.value,
          getLoginBoxMessage: getLoginBoxMessage.value,
          onOpenMyPageLink: openMyPageLink,
          id: "login-state",
          "data-login-state": login.value ? 'loggedin' : 'guest'
        }, null, 8, ["login", "getLoginBoxMessage", "data-login-state"]))
      : _createCommentVNode("", true),
    (!login.value && !_unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (timetableTopGuest.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: timetableTopGuest.value
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createVNode(CarouselBox, { login: login.value }, null, 8, ["login"])
        ]))
      : _createCommentVNode("", true),
    (login.value && !_unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(NoticeBox, { axiosOptions: axiosOptions }),
          (timetableTopLogin.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: timetableTopLogin.value
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!login.value && _unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (singleTopGuest.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: singleTopGuest.value
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (login.value && _unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (singleTopLogin.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: singleTopLogin.value
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(sessions) && _unref(sessions).length === 0 && _unref(getSessionsFail) === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      : _createCommentVNode("", true),
    (_unref(getSessionsFail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (getSessionsErrorMessage.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: getSessionsErrorMessage.value
              }, null, 8, _hoisted_15))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(sessions) && _unref(sessions).length)
      ? (_openBlock(), _createBlock(HomeView, {
          key: 9,
          single: _unref(single),
          cart: cart.value,
          entryList: entryList.value,
          sessions: _unref(sessions),
          seminar_session: _unref(seminar_session),
          shareURL: _unref(shareURL),
          onAddItem: addItem,
          onRemoveItem: removeItem,
          onCancelItem: cancelItem,
          onSubmitForm: submitForm,
          login: login.value,
          webinarMainLabel: _unref(webinarMainLabel),
          webinarSubLabel: _unref(webinarSubLabel),
          eventHolding: _unref(eventHolding),
          eventAPIisAlive: _unref(eventAPIisAlive),
          onOpenLink: openLink,
          onOpenLinkWithNewWindow: openLinkWithNewWindow,
          onOpenExternalLink: openExternalLink,
          onOpenExternalLinkWithNewWindow: openExternalLinkWithNewWindow
        }, null, 8, ["single", "cart", "entryList", "sessions", "seminar_session", "shareURL", "login", "webinarMainLabel", "webinarSubLabel", "eventHolding", "eventAPIisAlive"]))
      : _createCommentVNode("", true),
    (!login.value && !_unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (timetableBottomGuest.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: timetableBottomGuest.value
              }, null, 8, _hoisted_17))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (login.value && !_unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (timetableBottomLogin.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: timetableBottomLogin.value
              }, null, 8, _hoisted_19))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!login.value && _unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (singleBottomGuest.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: singleBottomGuest.value
              }, null, 8, _hoisted_21))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (login.value && _unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (singleBottomLogin.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: singleBottomLogin.value
              }, null, 8, _hoisted_23))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(sessions) && _unref(sessions).length)
      ? (_openBlock(), _createElementBlock("form", {
          key: 14,
          action: _unref(formBaseURL) + ( login.value ? '/mypage/edt.php' : '/' ),
          method: "post",
          class: "d-none",
          ref_key: "webtanForm",
          ref: webtanForm
        }, null, 8, _hoisted_24))
      : _createCommentVNode("", true),
    (_unref(timezoneError))
      ? (_openBlock(), _createBlock(TimezoneErrorModal, {
          key: 15,
          onCloseTimezoneErrorModal: closeTimezoneErrorModal,
          message: _unref(timezoneErrorMessage)
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_unref(confirmCancel))
      ? (_openBlock(), _createBlock(ConfirmCancelModal, {
          key: 16,
          onColseConfirmCancelModal: colseConfirmCancelModal,
          message: _unref(confirmCancelMessage),
          cancelSession: _unref(cancelSession),
          onDoCancelSession: doCancelSession
        }, null, 8, ["message", "cancelSession"]))
      : _createCommentVNode("", true)
  ]))
}
}

})